import { parseAsBoolean, useQueryStates } from '@/libs/nuqs'

const useWorkflowEditorParams = () => {
	const [params, setParams] = useQueryStates({
		editWorkflowInfo: parseAsBoolean,
	})

	return { ...params, setParams }
}

export { useWorkflowEditorParams }
